import React from "react"
import {
  useNavigate,
  useParams,
  useLocation,
  resolvePath
} from "react-router-dom"
import Box from "@mui/material/Box"
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined"

import { PageTitle } from "../../../components/typography"

import { CompanyPaymentsIndex } from "../payments/CompanyPaymentsIndex"
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty"
import { MyPackage } from "../packages/MyPackage"
import { ModalPackageContextProvider } from "../../../contexts/package-modal-context"
import { MyCompanyAbout } from "../company/MyCompanyAbout"
import { PaymentForm } from "../../../components/forms/PaymentForm"

type TabData = {
  path: string
  label?: string
  element?: React.ReactNode
  icon?: React.ReactNode
}

const tabs: TabData[] = [
  {
    path: "paymentForm",
    label: "Dane rozliczeniowe",
    element: <PaymentForm />,
    icon: <FlagOutlinedIcon />
  },
  // {
  //   path: "payments",
  //   label: "Płatności",
  //   element: <CompanyPaymentsIndex />,
  //   icon: <FlagOutlinedIcon />,
  // },
  {
    path: "list",
    label: "Lista",
    element: <MyPackage />,
    icon: <HourglassEmptyIcon />
  }
]

export const PaymentsIndex = () => {
  const { tab } = useParams()
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const tabIndex = tabs.findIndex((tabData: TabData) => tabData["path"] === tab)
  if (tabIndex < 0) navigate(resolvePath(`../paymentForm`, pathname))

  return (
    <ModalPackageContextProvider>
      <div className="p-[40px] ">
        <PageTitle>Rozliczenia</PageTitle>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={tabIndex}
            aria-label="organizatorze tab"
            variant="scrollable"
          >
            {tabs.map((tab) => (
              <Tab
                onClick={() =>
                  navigate(resolvePath(`../${tab["path"]}`, pathname))
                }
                label={
                  <div className="flex justify-center items-center">
                    <div className="mr-1">{tab["icon"]}</div>
                    {tab["label"] ?? tab["path"]}
                  </div>
                }
                key={tab["path"]}
              />
            ))}
          </Tabs>
        </Box>
        {tabs[tabIndex]["element"]}
      </div>
    </ModalPackageContextProvider>
  )
}
